import {
  Checkbox,
  GiftItemStatus,
  IGiftItemResponse,
  ITicketQuestion,
  StateAction,
} from '@one-tree/library'
import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { IGiftItemPostBody } from '../../../../../types/GiftItemTypes'
import { priceUsingQuestion } from '../TicketPrices/pricesHelper'

const Styles = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 5px;
  margin-bottom: 3px;
`
type Props = {
  question: ITicketQuestion
  questions: number[]
  ticket: IGiftItemResponse
  changeTicket: (changes: IGiftItemPostBody) => void
  onToggleQuestion: (enabledQuestionIds: number[]) => void
  onPriceToggle: (priceId: number, enabledQuestionIds: number[]) => void
  setDisableDelete: StateAction<number[]>
}
export default function EnableQuestion(props: Props): ReactElement {
  const {
    question,
    questions,
    ticket,
    changeTicket,
    onToggleQuestion,
    onPriceToggle,
    setDisableDelete,
  } = props
  const { prices } = ticket

  const activePrices = ticket.prices
    && [...ticket.prices].filter(
      ({ status }) => status !== GiftItemStatus.Archived,
    )

  const enableQuestionOnParent = (): void => {
    setDisableDelete((p) => [...p, question.id])
    onToggleQuestion([...questions, question.id])
  }
  const disableQuestionOnParent = (): void => {
    setDisableDelete((p) => p.filter((id) => id !== question.id))
    onToggleQuestion(questions.filter((id) => id !== question.id))
  }

  // If this Ticket has active Prices:
  if (prices?.length && activePrices?.length) {
    return (
      <Styles>
        {activePrices.map((price) => {
          const { id, name, enabledQuestionIds } = price

          const handleChange = (value: boolean): void => {
            const priceIndex = prices.findIndex((each) => each.id === id)
            const enabled = enabledQuestionIds || []
            const newEnabledQuestionIds = value
              ? [...enabled, question.id]
              : enabled.filter((questionId) => questionId !== question.id)

            const updatedPrices = [...prices]
            updatedPrices[priceIndex] = {
              ...price,
              enabledQuestionIds: newEnabledQuestionIds,
            }

            if (value) {
              setDisableDelete((p) => [...p, question.id])
            } else if (!priceUsingQuestion(question.id, updatedPrices)) {
              // Re-enable delete once no active price uses this question
              setDisableDelete((p) => p.filter((each) => each !== question.id))
            }

            // Stage the change, saved on Save in EditGiftItem
            changeTicket({ prices: updatedPrices })
            if (id !== undefined) onPriceToggle(id, newEnabledQuestionIds)
          }

          return (
            <Checkbox
              key={`${name}${id}`}
              label={name}
              value={enabledQuestionIds?.includes(question.id) || false}
              onChange={handleChange}
            />
          )
        })}
      </Styles>
    )
  }

  // If Ticket does not have active Prices, disable questions on inactive prices and render normally
  if (prices) {
    prices.forEach((each, index) => {
      if (each.enabledQuestionIds?.includes(question.id)) {
        const updatedPrices = [...prices]

        const updatedPrice = {
          ...each,
          enabledQuestionIds: each.enabledQuestionIds.filter(
            (questionId) => questionId !== question.id,
          ),
        }

        updatedPrices[index] = updatedPrice

        changeTicket({ prices: updatedPrices })
      }
    })
  }

  return (
    <Checkbox
      value={questions.includes(question.id) || false}
      onChange={(value): void => (value ? enableQuestionOnParent() : disableQuestionOnParent())}
      style={{ verticalAlign: 'middle' }}
    />
  )
}
